import React from 'react';
import { Link } from 'react-router-dom';
import './LimitedAdvise.css'; // Ensure your CSS file is correctly imported

const LimitedAdvise = ({ width, height, message, tooltipTitle, tooltipPhrases, tooltipPosition = 'top', tooltipWidth = '200px' }) => {
  return (
    <div
      className={`tooltip-box ${tooltipPosition}`}
      style={{ width, height }}
    >
      {message}      
      <div
        className="tooltip-content"
        style={{ width: tooltipWidth }}
      >
        <h3 className="tooltip-title">{tooltipTitle}</h3>
        <ul className="tooltip-list">
          {tooltipPhrases.map((phrase, index) => (
            <li key={index}>
              <i className="bi bi-x-circle" style={{ color: 'red', marginRight: '10px', fontSize: '18pt' }}></i> {phrase}
            </li>
          ))}
        </ul>
        <div className="tooltip-footer" style={{ marginTop: '10px' }}>
          <Link to={'/Shop'} className="tooltip-footer-link">
            {'Learn More'}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default LimitedAdvise;